// API base URL.
// Локальный тест: frontend/.env.local задаёт VITE_API_BASE=same-origin,
// а Vite проксирует /api на отдельный тестовый backend.
// Боевой домен всегда обращается к отдельному API. Это защищает от случайной
// сборки с локальной .env.local (same-origin), где /api вернёт HTML приложения.
const productionApi = 'https://api.rasklad.shop';
const configuredApi = import.meta.env.VITE_API_BASE;
export const API_BASE = window.location.hostname === 'webapp.rasklad.shop'
  ? productionApi
  : configuredApi === 'same-origin' ? window.location.origin : (configuredApi || productionApi);
